import React from 'react';
import { connect } from 'react-redux';
import { logout, fetchTimezonesIfNeeded, fetchCountriesIfNeeded, updateUserLocal
  } from 'common/ducks/user';
import { fetchLanguagesIfNeeded } from 'profile/ducks/languages';
import { fetchIdPhotoIfNeeded } from 'registration/creative/ducks';
import Info from 'account/components/info';

const mapStateToProps = (state) => {
  const { timezones, countries } = state.user;
  const { idValidated } = state.creativeRegistration;

  return {
    user: state.user,
    languages: state.profile.languages.data,
    timezones,
    countries,
    idValidated
  };
};

const mapDispatchToProps = {
  fetchLanguagesIfNeeded,
  fetchTimezonesIfNeeded,
  fetchCountriesIfNeeded,
  fetchIdPhotoIfNeeded,
  logout,
  updateUserLocal
}

export default connect(mapStateToProps, mapDispatchToProps)(Info);



// WEBPACK FOOTER //
// ./account/containers/info.jsx